import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export type BadgeType = 
  | 'EARLY_SUPPORTER'
  | 'YEAR_MEMBER'
  | 'TOP_PATRON'
  | 'REFERRAL_MASTER'
  | 'FOUNDING_MEMBER'
  | 'LOYAL_SUPPORTER';

export interface Badge {
  id: string;
  patronAccountId: string;
  badgeType: BadgeType;
  title: string;
  description?: string;
  iconUrl?: string;
  earnedAt: string;
}

export const badgesService = {
  async getMyBadges() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/badges/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { badges: Badge[] };
  },

  async getUserBadges(userId: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/badges/user/${userId}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    });
    return res.data as { badges: Badge[] };
  },

  async awardBadge(data: {
    patronAccountId: string;
    badgeType: BadgeType;
    title: string;
    description?: string;
    iconUrl?: string;
  }) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/badges`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { badge: Badge };
  },

  async revokeBadge(badgeId: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.delete(`${API_BASE_URL}/api/badges/${badgeId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },
};
